import { AbstractControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import * as moment from 'moment';
import { DateUtils, MY_DATE_FORMATS } from '@awp/core/utils';

export class DateValidators {

  static isValid(control: AbstractControl): ValidationErrors {
    if (control.value === null) return null;

    if (!DateUtils.isDate(control.value)) {
      return { invalid: true };
    }

    return null;
  }

  static maxDate(maxDate: any): ValidatorFn {
    if (!moment.isDate(maxDate)) {
      throw Error('maxDate value must be or return a formatted date');
    }

    const maxDateValue = new Date(maxDate);

    return (control: AbstractControl): ValidationErrors => {
      if (Validators.required(control) != null) return null;

      const d: Date = new Date(control.value);

      if (!DateUtils.isDate(d)) {
        return null;
      }

      if (maxDate instanceof Function) maxDate = maxDate();

      return d <= maxDateValue ? null : { maxDate: true };
    };
  };

  static minAge(minAge: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      if (Validators.required(control) != null) return null;

      const d: Date = new Date(control.value);

      if (!moment.isDate(d)) return { invalid: true };

      const age = DateUtils.age(d);

      if (age < minAge) {
        return {
          minimumAge: {
            'minimum': minAge,
            'actual': age
          }
        }
      } else {
        return null;
      }
    }
  }

  static maxAge(maxAge: number): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
      if (Validators.required(control) != null) return null;

      const d: Date = new Date(control.value);

      if (!moment.isDate(d)) return { invalid: true };

      const age = DateUtils.age(d);

      if (age > maxAge) {
        return {
          maximumAge: {
            'maxiumum': maxAge,
            'actual': age
          }
        }
      } else {
        return null;
      }
    }
  }

  static validDate(minInput?: Date, maxInput?: Date): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let datePattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
      if (typeof control.value === 'string' || control.value instanceof String) {
        if (control.value && !control.value.match(datePattern)) {
          return { 'invalidDateFormat': { format: MY_DATE_FORMATS.parse.dateInput } };
        }
        if (control.value && control.value.match(datePattern) && !moment(control.value.toString(), MY_DATE_FORMATS.parse.dateInput, true).isValid()) {
          return { 'invalidDateFormat': { value: control.value } };
        }

        if (control.value && control.value.match(datePattern) && moment(control.value.toString(), MY_DATE_FORMATS.parse.dateInput, true).isValid()) {
          if (DateValidators.compareDate(control.value.toString(), minInput) < 0 ) {
            return { 'minDate': { minInput: minInput } };
          } else if (DateValidators.compareDate(control.value.toString(), maxInput) > 0 ) {
            return { 'maxDate': { maxInput: maxInput } };
          }
        }
      }
      return null;
    }
  }

  static startFromToday(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value && moment(control.value.toString(), MY_DATE_FORMATS.parse.dateInput, true).isValid()) {
          if (DateValidators.compareDate(control.value.toString(), DateUtils.today()) < 0) {
            return { 'earlierThanToday': { minInput: DateUtils.today() } };
          }
        }
      }
      return null;
  }
  

  // Compare the date part of two dates in multiple date compatible formats defined in momentInput
  // Return number greater than 0 if first date is later than second date
  // Return 0 if first date is the same as the second date
  // Return number less than 0 if first date is earlier than second date
  static compareDate(firstDate: moment.MomentInput, secondDate: moment.MomentInput): number {
    return moment(firstDate, MY_DATE_FORMATS.parse.dateInput, true).startOf('day').diff(moment(secondDate, MY_DATE_FORMATS.parse.dateInput, true).startOf('day'),'days');
  }

}
